import { render, staticRenderFns } from "./HTYVerifyPhoneForm.vue?vue&type=template&id=bb8ae4ec&scoped=true&"
import script from "./HTYVerifyPhoneForm.vue?vue&type=script&lang=js&"
export * from "./HTYVerifyPhoneForm.vue?vue&type=script&lang=js&"
import style0 from "./HTYVerifyPhoneForm.vue?vue&type=style&index=0&id=bb8ae4ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8ae4ec",
  null
  
)

export default component.exports